module.exports = new __parcel__URL__("WorkListEmpty_ptc.c984a049.svg").toString();